
import Empty from '../components/Empty.vue'
import BM from '../components/js/common'
import * as Api from '../service/Api';
import WeiboJS from '../components/js/sinaShare';
import share from '../components/js/share';
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

export default{
data(){
return {
hasData: '',
index:0,
meetingListData: [],
meetingTimeline : [],
headTitle: '',
meetingId: true,
showMore: false,
mc: this.$route.query.mc,
sMc: '',
hasPaySuccess: false,
imgUrl: '',
contact: {},
swipH:(document.body.clientHeight-44)+"px",
lectorId:"",
toastText:"",
showphone:false,
teleArr: [{
"intl_tele_code": "86",
"name": "中国",
"short_name": "CN +86"
},
{
"intl_tele_code": "81",
"name": "日本",
"short_name": "JP +81"
},
{
"intl_tele_code": "852",
"name": "香港",
"short_name": "HK +852"
},
{
"intl_tele_code": "853",
"name": "澳门",
"short_name": "MO +853"
},
{
"intl_tele_code": "886",
"name": "台湾",
"short_name": "TW +886"
},
{
"intl_tele_code": "82",
"name": "韩国",
"short_name": "KR +82"
},
{
"intl_tele_code": "1",
"name": "美国",
"short_name": "US +1"
},
{
"intl_tele_code": "44",
"name": "英国",
"short_name": "UK +44"
},
{
"intl_tele_code": "49",
"name": "德国",
"short_name": "DE +49"
},
{
"intl_tele_code": "33",
"name": "法国",
"short_name": "FR +33"
},
{
"intl_tele_code": "66",
"name": "泰国",
"short_name": "TH +66"
},
{
"intl_tele_code": "65",
"name": "新加坡",
"short_name": "SG +65"
},
{
"intl_tele_code": "60",
"name": "马来西亚",
"short_name": "MY +60"
},
{
"intl_tele_code": "61",
"name": "澳大利亚",
"short_name": "AU +61"
}
],
biz: "86",
phone:"",
bacheight:"",
showHeader:true,
}
},
created(){
let cover=document.body.clientWidth-20;
var bacheight=parseInt(cover/2.15)+"px";
this.bacheight=bacheight;
var ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
this.showHeader=false;
}
},
mounted(){
this.$vux.loading.show({
text: '數據加載中',
})
this.getMeetingData();
},
methods:{


showPhone(id){
this.showphone=true;

},
cancelVer(){
this.showphone=false
},
getMeetingData(defaultMc){
let that = this;
this.$ajax.get(Api.meetingList, {  //params参数必写 , 如果没有参数传{}也可以
params: {
lectorId:that.lectorId
}
})
.then(function (res) {
if(res.data.code == '200'){
if(res.data.data.length>0){
that.hasData = true;
that.meetingListData = res.data.data;
}else{
that.hasData = false;
}
that.$vux.loading.hide();
}else{
that.$vux.loading.hide();
that.toastText="加載失敗，請稍後重試";
that.showToast = true;
that.hasData = false;
}
})
.catch(function (err) {
that.$vux.loading.hide();
that.toastText="加載失敗，請稍後重試";
that.showToast = true;
that.hasData = false;
});
},





































toMeetdetail(d,wk){






this.$router.push({path: '/detail', query: {id: d,weekend:wk}});


},
},
components:{XButton,Empty ,XImg,XHeader,}
}



// WEBPACK FOOTER //
// ./src/pages/Timeline.vue